<template>
    <div>
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('closeModal')">
                    <div 
                        class="modal-container" 
                        :class="{ 
                            'modal-file-mode': page === 'file', 
                            'modal-satuan-mode': page === 'satuan', 
                            'modal-select-mode': page === 'selectMethod' 
                        }" 
                        @click.stop
                    >
                        <!-- Header -->
                        <div 
                            class="modal-header-custom d-flex justify-content-between align-items-center"
                            :class="{ 'modal-header-file': page === 'file' }"
                        >
                            <div class="d-flex align-items-center">
                                <img 
                                    v-if="page === 'satuan'"
                                    src="@/assets/img/svg/arrow-left.svg" 
                                    alt="Back" 
                                    class="back-icon mr-2" 
                                    @click="page = 'selectMethod'" 
                                />
                                <h5 class="modal-title-custom mb-0">{{ title }}</h5>
                            </div>
                            <button class="btn btn-close-custom" @click="$emit('closeModal')">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <!-- Body -->
                        <div class="modal-body-wrapper">
                            <!-- Mode 1: Select Method -->
                            <div v-if="page === 'selectMethod'" class="p-4 text-center">
                                <b-container>
                                    <b-row class="justify-content-center">
                                        <b-col cols="12" md="6" class="p-3" @click="page = 'satuan'">
                                            <div class="boxHover border border-grey rounded text-center d-flex flex-column align-items-center justify-content-center p-4" style="height:320px; cursor: pointer;">
                                                <img src="@/assets/img/icon/pengiriman-satuan.png" style="width:auto; height: 5em;" class="mb-4"/>
                                                <h4 class="font-weight-bold" style="color: #111827;">Pengiriman Satuan</h4>
                                                <p class="text-muted mb-0">Buat pengiriman untuk satu destinasi dealer</p>
                                            </div>
                                        </b-col>
                                        <b-col cols="12" md="6" class="p-3" @click="page = 'file'">
                                            <div class="boxHover border border-grey rounded text-center d-flex flex-column align-items-center justify-content-center p-4" style="height:320px; cursor: pointer;">
                                                <img src="@/assets/img/icon/pengiriman-gabungan.png" style="width:auto; height: 5em;" class="mb-4"/>
                                                <h4 class="font-weight-bold" style="color: #111827;">Pengiriman Gabungan</h4>
                                                <p class="text-muted mb-0">Buat pengiriman untuk berbagai destinasi dealer</p>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </div>

                            <!-- Mode 2: Satuan -->
                            <div v-else-if="page === 'satuan'" class="modal-body-custom">
                                <div class="modal-form-row">
                                    <label class="modal-form-label mb-0">Dealer Tujuan</label>
                                    <div class="modal-form-input">
                                        <Multiselect 
                                            v-model="satuan.kode_dealer"
                                            :options="dealerCodeOptions"
                                            :custom-label="getDealerLabel"
                                            placeholder="Select Dealer"
                                            :show-labels="false"
                                            :searchable="true"
                                            :allow-empty="false"
                                            class="custom-modal-select"
                                        />
                                    </div>
                                </div>

                                <div class="modal-form-row">
                                    <label class="modal-form-label mb-0">Jumlah QR</label>
                                    <div class="modal-form-input">
                                        <input type="number" class="form-control modal-input" v-model.number="satuan.qty" placeholder="0" min="0" />
                                    </div>
                                </div>

                                <div class="modal-form-row align-top">
                                    <label class="modal-form-label mb-0 pt-2">Tanda Tangan</label>
                                    <div class="modal-form-input">
                                        <div class="signature-box-satuan">
                                            <vue-signature-pad width="100%" height="130px" ref="signaturePad" />
                                            <button 
                                                type="button" 
                                                class="btn-clear-signature" 
                                                @click="$refs.signaturePad.clearSignature()"
                                            >
                                                Hapus
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-actions-row-satuan d-flex justify-content-end align-items-center">
                                    <button 
                                        type="button" 
                                        class="btn btn-batal-satuan" 
                                        @click="$emit('closeModal')"
                                    >
                                        Batal
                                    </button>
                                    <button 
                                        type="button" 
                                        class="btn btn-submit-satuan" 
                                        @click="handleKirimClick"
                                    >
                                        Kirim
                                    </button>
                                </div>
                            </div>

                            <!-- Mode 3: Pengiriman Gabungan (file) -->
                            <div v-else class="modal-body-file">
                                <!-- Upload Box -->
                                <div 
                                    class="upload-dropzone"
                                    @drop.prevent="validateSize"
                                    @dragover.prevent
                                >
                                    <img src="@/assets/img/icon/upload-csv.png" class="upload-icon" alt="Upload CSV" />
                                    <h6 class="upload-title">Upload CSV</h6>
                                    <p class="upload-subtitle">Seret dan masukkan file CSV untuk memulai upload</p>
                                
                                    <label class="custom-file-btn mb-0">
                                        <input type="file" @change="validateSize" accept=".csv, .xlsx, .xls" hidden />
                                        <span class="btn-choose">Choose File</span>
                                        <span class="file-name">{{ file ? file.name : 'data pos.csv' }}</span>
                                    </label>
                                
                                    <p v-if="fileError" class="text-danger mt-2 mb-0 font-weight-normal" style="font-size: 11px;">{{ fileError }}</p>
                                </div>

                                <!-- Template Hint -->
                                <div class="template-hint">
                                    <span>jika anda tidak mempunyai templatenya download <a href="/template/Data pengiriman Sticker QR Code ke Dealer atau AHASS.xlsx" class="link-download">disini</a></span>
                                </div>

                                <!-- Signature Row -->
                                <div class="signature-form-row">
                                    <label class="signature-label mb-0">Tanda Tangan</label>
                                    <div class="signature-box">
                                        <vue-signature-pad width="100%" height="116px" ref="signaturePad" />
                                        <button
                                            type="button"
                                            class="btn-clear-sig"
                                            @click="$refs.signaturePad.clearSignature()"
                                        >
                                            Hapus
                                        </button>
                                    </div>
                                </div>

                                <!-- Actions -->
                                <div class="modal-actions-row">
                                    <button 
                                        type="button" 
                                        class="btn btn-batal" 
                                        @click="$emit('closeModal')"
                                    >
                                        Batal
                                    </button>
                                    <button 
                                        type="button" 
                                        class="btn btn-konfirmasi" 
                                        @click="uploadFile"
                                    >
                                        Konfirmasi
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <confirm-pengiriman-modal
            :show="showConfirmModal"
            :qty="satuan.qty"
            :dealer-label="getDealerLabel(satuan.kode_dealer)"
            :is-submitting="isSubmitting"
            @cancel="showConfirmModal = false"
            @confirm="confirmAndSend"
        />
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import ConfirmPengirimanModal from './ConfirmPengirimanModal.vue';

    export default {
        components :{
            Multiselect,
            ConfirmPengirimanModal
        },
        data() {
            return {
                page : 'selectMethod',
                title : 'Metode Pengiriman',
                masterPage : [{
                    page : 'selectMethod',
                    title : 'Metode Pengiriman'
                },{
                    page : 'file',
                    title : 'Pengiriman Gabungan'
                },{
                    page : 'satuan',
                    title : 'Pengiriman Satuan'
                }],
                satuan : {
                    kode_dealer : '',
                    qty : 0,
                    sender_signature : null
                },
                dealerData : this.$store.state.filterOptions.dealer || [],
                file : null,
                fileError : "",
                showConfirmModal : false,
                isSubmitting : false
            }
        },
        watch : {
            page : function () {
                this.title = this.masterPage.find(x => this.page == x.page).title;
                this.resetBody();
            }
        },
        computed: {
            dealerCodeOptions() {
                const codes = this.dealerData.map(x => x.code).filter(Boolean);
                if (this.satuan.kode_dealer && !codes.includes(this.satuan.kode_dealer)) {
                    return [this.satuan.kode_dealer, ...codes];
                }
                return codes;
            }
        },
        mounted() {
            if (this.$store.getters && this.$store.getters.getDealer) {
                const dealers = this.$store.getters.getDealer();
                if (dealers && dealers.length) {
                    this.dealerData = dealers;
                }
            }
        },
        methods: {
            getDealerLabel(code) {
                if (!code) return '';
                const dealer = this.dealerData.find(x => x.code === code);
                if (dealer) {
                    if (dealer.name) {
                        return dealer.name.includes(dealer.code) ? dealer.name : `${dealer.code} - ${dealer.name}`;
                    }
                    return dealer.code;
                }
                return code;
            },
            resetBody() {
                this.satuan.kode_dealer = '';
                this.satuan.qty = 0;
                this.satuan.sender_signature = null;
                this.file = null;
                this.fileError = '';
                this.showConfirmModal = false;
                this.isSubmitting = false;
                if (this.$refs.signaturePad) {
                    this.$refs.signaturePad.clearSignature();
                }
            },
            handleKirimClick() {
                let errors = [];
                if (!this.satuan.kode_dealer) errors.push('Dealer Tujuan wajib dipilih');
                if (!this.satuan.qty || this.satuan.qty <= 0) errors.push('Jumlah QR tidak boleh 0');

                let isSigEmpty = true;
                let sigData = null;
                if (this.$refs.signaturePad) {
                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                    isSigEmpty = isEmpty;
                    if (!isEmpty) {
                        sigData = data.split(",")[1];
                    }
                }

                if (isSigEmpty) errors.push('Tanda tangan wajib diisi');

                if (errors.length > 0) {
                    this.$swal.fire({
                        title: "Error",
                        html: `<p>> ${errors.join("<br>> ")}</p>`,
                        icon: "error",
                    });
                    return;
                }

                this.satuan.sender_signature = sigData;
                this.showConfirmModal = true;
            },
            async confirmAndSend() {
                if (this.isSubmitting) return;
                this.isSubmitting = true;
                try {
                    await this.$http.post('/api/qrs/issue/create', this.satuan);

                    this.showConfirmModal = false;
                    this.$emit('updateTable');
                    this.$emit('closeModal');
                    this.resetBody();
                }
                catch(err) {
                    console.log(err);
                    this.$swal.fire({
                        title: "Error",
                        text: err.response && err.response.data && err.response.data.message ? err.response.data.message : (err.message || "Gagal membuat pengiriman"),
                        icon: "error"
                    });
                }
                finally {
                    this.isSubmitting = false;
                }
            },
            validateSize(data) {
                const file = data.dataTransfer ? data.dataTransfer.files[0] : (data.target && data.target.files ? data.target.files[0] : null);
                if (!file) return false;

                const isCsvOrExcel = file.type === "text/csv" || 
                    file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                    file.type === 'application/vnd.ms-excel' ||
                    file.name.endsWith('.csv') ||
                    file.name.endsWith('.xlsx');

                if (!isCsvOrExcel) {
                    this.fileError = "Format file tidak didukung! Hanya file CSV atau XLSX yang diperbolehkan";
                    return false;
                }

                const sizeMb = file.size / 1024 / 1024;
                if (sizeMb > 2) {
                    this.fileError = "Ukuran file terlalu besar (maksimal 2MB)";
                    return false;
                }

                this.fileError = "";
                this.file = file;
                return true;
            },
            uploadFile() {
                let vm = this;
                let url = "/api/qrs/issue/upload";
                
                let isSigEmpty = true;
                let dataSignature = null;
                if (this.$refs.signaturePad) {
                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                    isSigEmpty = isEmpty;
                    if (!isEmpty) {
                        dataSignature = data.split(",")[1];
                    }
                }

                let errors = [];
                if (!this.file) errors.push("Silakan pilih file CSV terlebih dahulu");
                if (isSigEmpty) errors.push("Tanda tangan wajib diisi");

                if (errors.length > 0) {
                    this.$swal.fire({
                        title: "Error",
                        html: `<p>> ${errors.join("<br>> ")}</p>`,
                        icon: "error",
                    });
                    return;
                }

                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('sender_signature', dataSignature);

                this.$http.post(url, formData, { headers: { "Content-Type": 'multipart/form-data' } })
                .then((resp)=>{
                    if (resp.data.code != 200) {
                        this.$swal.fire({
                            title: "Error",
                            text: resp.data.message,
                            icon: "error",
                        });
                        return;
                    }

                    this.$swal.fire({
                        title: "Success",
                        text: "Bulk Input Success",
                        icon: "success",
                    });

                    vm.$emit('updateTable');
                    vm.$emit('closeModal');
                })
                .catch((err)=>{
                    console.log(err);
                    this.$swal.fire({
                        title: "Error",
                        text: "Bulk Input Failed: " + err,
                        icon: "error",
                    });
                });
            }
        }
    }
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    padding: 20px;
}

.modal-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-container {
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    padding: 0;
    overflow: hidden;
    transform: rotate(0deg);
    opacity: 1;
}

.modal-container.modal-file-mode {
    width: 521px;
    max-width: 521px;
    height: 562px;
    min-height: 562px;
    display: flex;
    flex-direction: column;
}

.modal-container.modal-satuan-mode {
    width: 521px;
    max-width: 521px;
    min-height: 357px;
}

.modal-container.modal-select-mode {
    width: 650px;
    max-width: 90vw;
}

.modal-header-custom {
    padding: 16px 20px;
    border-bottom: 1px solid #F3F4F6;
}

/* Modal header specific to Pengiriman Gabungan (file mode) */
.modal-header-file {
    padding: 21px 18px 0 49px;
    border-bottom: none;
}

.back-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
    object-fit: contain;
}

.modal-title-custom {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    line-height: 1.2;
}

.modal-header-file .modal-title-custom {
    font-size: 16px;
    line-height: 23px;
}

.btn-close-custom {
    padding: 0;
    border: none;
    background: transparent;
    color: #111827;
    font-size: 18px;
    cursor: pointer;
    line-height: 1;
}

.modal-header-file .btn-close-custom {
    font-size: 16px;
    margin-right: 0;
}

.btn-close-custom:hover {
    color: #6B7280;
}

/* Body specific to Pengiriman Gabungan (file mode) */
.modal-body-file {
    padding: 38px 56px 20px 48px;
    display: flex;
    flex-direction: column;
}

/* Upload Dropzone Box */
.upload-dropzone {
    width: 417px;
    height: 225px;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    padding-top: 47px;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    transition: border-color 0.2s;
}

.upload-icon {
    height: 50px;
    width: auto;
    object-fit: contain;
    margin-bottom: 30px;
}

.upload-title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 15px;
    line-height: 1;
}

.upload-subtitle {
    font-size: 11px;
    color: #4B5563;
    margin-bottom: 17px;
    line-height: 1;
}

.custom-file-btn {
    display: inline-flex;
    align-items: center;
    background-color: #F36F21;
    border-radius: 4px;
    padding: 2px 12px 2px 4px;
    cursor: pointer;
    transition: background-color 0.2s;
    height: 26px;
    box-sizing: border-box;
}

.custom-file-btn:hover {
    background-color: #D95D16;
}

.custom-file-btn .btn-choose {
    background-color: #FFFFFF;
    color: #374151;
    border-radius: 3px;
    padding: 3px 10px;
    font-size: 11px;
    font-weight: 500;
    line-height: 1.2;
}

.custom-file-btn .file-name {
    color: #FFFFFF;
    font-size: 11px;
    font-weight: 400;
    margin-left: 10px;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Template Hint */
.template-hint {
    font-size: 11px;
    color: #374151;
    text-align: center;
    margin: 27px 0 26px 0;
    line-height: 14px;
}

.link-download {
    color: #4E80ED;
    text-decoration: none;
}

.link-download:hover {
    text-decoration: underline;
}

/* Signature Row */
.signature-form-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
}

.signature-label {
    width: 112px;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 600;
    color: #2F2F2F;
    padding-top: 2px;
}

.signature-box {
    width: 305px;
    height: 116px;
    flex-shrink: 0;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    position: relative;
    background: #FFFFFF;
    overflow: hidden;
    box-sizing: border-box;
}

.btn-clear-sig {
    position: absolute;
    bottom: 12px;
    right: 20px;
    background: transparent;
    border: none;
    color: #ADADAD;
    font-size: 13px;
    cursor: pointer;
    padding: 0;
    outline: none;
}

.btn-clear-sig:hover {
    color: #6B7280;
}

.modal-form-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}

.modal-form-row.align-top {
    align-items: flex-start;
}

.modal-form-label {
    width: 130px;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 600;
    color: #2F2F2F;
}

.modal-form-input {
    flex: 1;
    min-width: 0;
}

.modal-input {
    height: 38px;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 14px;
    color: #2F2F2F;
    background-color: #FFFFFF;
    box-shadow: none;
    outline: none;
    width: 100%;
}

.modal-input:focus {
    border-color: #F36F21;
    box-shadow: 0 0 0 1px #F36F21;
}

/* Actions */
.modal-actions-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.btn-batal {
    background: transparent;
    border: none;
    color: #F36F21;
    font-size: 13px;
    font-weight: 500;
    padding: 0;
    margin-right: 36px;
    box-shadow: none;
    cursor: pointer;
}

.btn-batal:hover {
    color: #D95D16;
    background: transparent;
}

.btn-konfirmasi {
    background-color: #F36F21;
    border: 1px solid #F36F21;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 500;
    border-radius: 4px;
    padding: 0;
    width: 99px;
    height: 32px;
    box-shadow: none;
    cursor: pointer;
    transition: background-color 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn-konfirmasi:hover {
    background-color: #D95D16;
    border-color: #D95D16;
    color: #FFFFFF;
}

/* Satuan Mode Specific Styles (matching EditPengirimanModal exactly) */
.modal-body-custom {
    padding: 20px 24px 24px 24px;
}

.signature-box-satuan {
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    position: relative;
    background: #FFFFFF;
    overflow: hidden;
    height: 130px;
    width: 100%;
}

.btn-clear-signature {
    position: absolute;
    bottom: 8px;
    right: 12px;
    background: transparent;
    border: none;
    color: #ADADAD;
    font-size: 13px;
    cursor: pointer;
    padding: 2px 6px;
    outline: none;
}

.btn-clear-signature:hover {
    color: #6B7280;
}

.modal-actions-row-satuan {
    margin-top: 24px;
}

.btn-batal-satuan {
    background: transparent;
    border: none;
    color: #F36F21;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    margin-right: 8px;
    box-shadow: none;
    cursor: pointer;
}

.btn-batal-satuan:hover {
    color: #D95D16;
    background: transparent;
}

.btn-submit-satuan {
    background-color: #F36F21;
    border: 1px solid #F36F21;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    padding: 8px 28px;
    box-shadow: none;
    cursor: pointer;
    transition: background-color 0.2s;
}

.btn-submit-satuan:hover {
    background-color: #D95D16;
    border-color: #D95D16;
    color: #FFFFFF;
}

.boxHover:hover {
    background-color: #F9FAFB;
    border-color: #F36F21 !important;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
}
</style>

<style>
/* Multiselect overrides inside modal */
.custom-modal-select.multiselect {
    min-height: 38px;
    font-size: 14px;
}

.custom-modal-select .multiselect__tags {
    min-height: 38px;
    height: 38px;
    padding: 8px 36px 0 12px;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    background: #FFFFFF;
}

.custom-modal-select .multiselect__single {
    margin-bottom: 0;
    padding-left: 0;
    font-size: 14px;
    color: #2F2F2F;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.custom-modal-select .multiselect__select {
    height: 38px;
    width: 36px;
    padding: 4px 8px;
}

.custom-modal-select .multiselect__select::before {
    border-color: #2F2F2F transparent transparent;
    border-width: 5px 4px 0 4px;
}

.custom-modal-select .multiselect__placeholder {
    margin-bottom: 0;
    padding-top: 0;
    font-size: 14px;
    color: #9CA3AF;
    line-height: 20px;
}

.custom-modal-select .multiselect__input {
    font-size: 14px;
    margin-bottom: 0;
    padding-left: 0;
    line-height: 20px;
}

.custom-modal-select .multiselect__content-wrapper {
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    max-height: 200px;
}
</style>